/**
 * Service: membershipOffering
 */
angular.module('acme.common.service.membership.offering', [
  'acme.common.service.api',
  'acme.common.service.membership'
])
.service('MembershipOfferingService', [ '$q', 'ApiService', 'MembershipService', function($q, ApiService, MembershipService) {

    return {

      model: {},
      details: {},
      policies: {},
      lifecycle: {},
      deletedRules: [],

      ready: {
        details: false,
        policies: false,
        lifecycle: false
      },

      loaded: {
        details: false,
        policies: false,
        lifecycle: false
      },

      init: function() {
        return true;
      },

      unReady: function() {
        this.ready.details = false;
        this.ready.policies = false;
        this.ready.lifecycle = false;
      },

      unLoaded: function() {
        this.loaded.details = false;
        this.loaded.policies = false;
        this.loaded.lifecycle = false;
      },

      createRule: function(rule) {
        return ApiService.rulesEngine.rule.create({
          templateId: rule.id
        });
      },

      updateRule: function(rule) {
        return ApiService.rulesEngine.rule.updateTrigger({
          templateId: rule.id,
          startMonth: rule.start,
          endMonth: rule.end
        });
      },

      removeRule: function(rule) {
        return ApiService.rulesEngine.rule.remove({ id: rule.id });
      },

      purgeRules: function() {
        var i, ii,
            self = this,
            promises = [];

        for (i = 0, ii = this.deletedRules.length; i < ii; i++) {
          promises.push(this.removeRule(this.deletedRules[i]));
        }

        $q.allSettled(promises).then(function(response) {

          var _response;

          while(_response = response.pop()) {

          }

          self.deletedRules = [];

        });
      },

      durationToMonths: function(duration) {
        var r = 0,
            years = 0,
            months = 0;

        if (duration) {
          if (duration.years || duration.years > 0) {
            years = parseInt(duration.years, 10);
          }
          if (duration.months || duration.years > 0) {
            months = parseInt(duration.months, 10);
          }

          if (!isNaN(years) && !isNaN(months)) {
            r = (years * 12) + months;
          }
        }

        return r;

      },

      monthsToDuration: function(months) {

        var r = {
              years: 0,
              months: 0
            },
            _years = parseInt(months / 12, 10),
            _months = parseInt(months % 12, 10);

        if (!isNaN(_months) && !isNaN(_years)) {
          r.years = _years;
          r.months = _months;
        }

        return r;
      },


      merge: function() {

        var i, ii,
            j, jj,
            action,
            actions = [];

        for (i = 0, ii = this.policies.length; i < ii; i++) {
          action = this.migrateSalesChannelOptions(this.policies[i]);
          action.ruleIds = [];

          for (j = 0, jj = this.lifecycle.length; j < jj; j++) {
            if (this.policies[i].action === this.lifecycle[j].action) {
              action.ruleIds = this.lifecycle[j].ruleIds;
              break;
            }
          }

          actions.push(action);
        }

        this.model = this.details;
        this.model.actions = actions;

      },

      findConfirmationEmailRestriction: function(confirmationEmailRestrictions, saleChannel) {

        var i, ii,
            r = false;

        for (i = 0, ii = confirmationEmailRestrictions.length; i < ii; i++) {
          if (confirmationEmailRestrictions[i].saleChannel === saleChannel) {
            r = {
              restriction: confirmationEmailRestrictions[i],
              index: i
            };
            break;
          }
        }

        return r;

      },

      migrateSalesChannelOptions: function(policy) {

        var i, ii,
            foundSaleChannel,
            foundRestriction;

        for (i = 0, ii = policy.salesChannelOptions.length; i < ii; i++) {

          if (policy.salesChannelOptions[i].saleChannelEntity) {
            foundSaleChannel = MembershipService.findSalesChannel(policy.salesChannels, policy.salesChannelOptions[i].saleChannelEntity.channel);
            if (foundSaleChannel) {
              policy.salesChannels[foundSaleChannel.index].enabled = policy.salesChannelOptions[i].saleChannelEntity.enabled;
            }
          }

          foundRestriction = this.findConfirmationEmailRestriction(policy.confirmationEmailRestrictions, policy.salesChannelOptions[i].saleChannel);
          if (foundRestriction) {
            policy.confirmationEmailRestrictions[foundRestriction.index].canSendConfirmationEmail = policy.salesChannelOptions[i].canSendConfirmationEmail;
          }

        }

        return policy;

      },

      getModel: function() {
        this.merge();

        /**
         * Makes sure there is only ever 1 price point per offering
         * @link https://acmeticketing.atlassian.net/browse/ENG-13785
         */
        this.model.priceLists.forEach(function (priceList) {
          priceList.prices = priceList.prices.slice(0, 1);
        });

        return this.model;
      }

    };

}]);